import React from 'react';
import { Plus, Pencil, Trash2, Clock, Coins, Calendar, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { CATEGORY_LABELS, formatDateTime, getCategoryColor } from './adminConstants';

export function AdminActivitiesSection({ 
    activities, 
    onOpenNewModal, 
    onEdit, 
    onDelete, 
    onViewAttendees 
}) {
    return (
        <div className="space-y-6" data-testid="admin-activities">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Activities Management</h2>
                <Button onClick={onOpenNewModal} data-testid="add-activity-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Activity
                </Button>
            </div>

            <div className="text-sm text-muted-foreground">
                {activities.length} activities total
            </div>
            
            <div className="space-y-3">
                {activities.map(activity => (
                    <div key={activity.id} className="card-base" data-testid={`activity-card-${activity.id}`}>
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <div className="flex-1">
                                <div className="flex flex-wrap items-center gap-2 mb-2">
                                    <span className={`text-xs font-bold px-2 py-1 rounded-full ${getCategoryColor(activity.category)}`}>
                                        {CATEGORY_LABELS[activity.category] || activity.category}
                                    </span>
                                    {activity.is_free && (
                                        <span className="text-xs font-bold px-2 py-1 rounded-full bg-emerald-100 text-emerald-700">
                                            FREE
                                        </span>
                                    )}
                                    <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600">
                                        <Coins className="w-3 h-3 inline mr-1" />
                                        {activity.is_free ? '0' : activity.credit_cost} credits
                                    </span>
                                </div>
                                <p className="font-bold text-lg">{activity.title}</p>
                                <p className="text-sm text-muted-foreground line-clamp-1">{activity.description}</p>
                                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-sm text-muted-foreground">
                                    <span><Clock className="w-3 h-3 inline mr-1" />{formatDateTime(activity.date_time)}</span>
                                    <span>{activity.location}</span>
                                    <span>{activity.current_bookings || 0}/{activity.capacity} booked</span>
                                </div>
                            </div>
                            <div className="flex gap-2 flex-shrink-0">
                                <Button 
                                    variant="outline" 
                                    size="sm" 
                                    onClick={() => onViewAttendees(activity)}
                                    data-testid={`view-attendees-${activity.id}`}
                                    title="View Attendees"
                                >
                                    <Users className="w-4 h-4" />
                                </Button>
                                <Button 
                                    variant="outline" 
                                    size="sm" 
                                    onClick={() => onEdit(activity)}
                                    data-testid={`edit-activity-${activity.id}`}
                                    title="Edit Activity"
                                >
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button 
                                    variant="destructive" 
                                    size="sm" 
                                    onClick={() => onDelete(activity)}
                                    data-testid={`delete-activity-${activity.id}`}
                                    title="Delete Activity"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                
                {activities.length === 0 && (
                    <div className="card-base text-center py-12">
                        <Calendar className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No activities yet</p>
                        <Button onClick={onOpenNewModal} className="mt-4">
                            Create First Activity
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
